import * as Yup from "yup";

export const fileValidationSchema = Yup.object({
  file: Yup.mixed()
    .test(
      "fileType",
      "Invalid file type. Please upload an Excel file (.xls, .xlsx) or CSV.",
      (file) => {
        const validTypes = [
          "application/vnd.ms-excel",
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          "text/csv",
        ];
        return file && validTypes.includes(file.type);
      }
    )
    .required("File is required"),
});
